import { render } from "./GetAddress.vue?vue&type=template&id=41481a8c"
import script from "./GetAddress.vue?vue&type=script&lang=js"
export * from "./GetAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__